import { PageScaffold } from "../../shared/ui/PageScaffold";

const adminLinks = [
  { to: "/t/:tenantSlug/teacher/admin", label: "管理ホーム" },
  { to: "/t/:tenantSlug/teacher/admin/recurring-slots", label: "枠設定" }
];

export function AdminLessonsPage() {
  return (
    <PageScaffold
      title="Admin Lessons"
      description="レッスン一覧画面のプレースホルダーです。"
      links={adminLinks}
    >
      <p>ここに lesson 一覧を表示します。</p>
    </PageScaffold>
  );
}
